import React, { useEffect, useState } from 'react';
import { Tabs, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import ApplicationStatusOverview from 'components/applicationStatusOverview';
const { TabPane } = Tabs;

const CustomTabsTimelineSub = ({
  tabs,
  tabProps,
  customClass,
  current,
  setCurrent,
  currentSubTab,
  ...rest
}) => {
  const dispatch = useDispatch();
  const activeTaskName = useSelector(state => state.forms?.activeTaskName);
  const businessKey = useSelector(state => state.forms?.businessKey);
  // const [activeTab, setActiveTab] = useState(current);//useState(tabs[0].id);
  // const onChange = key => {
  //   dispatch(
  //     updateFormField({
  //       group: 'carrier',
  //       key: 'currentSubTab',
  //       value: Number(key),
  //     })
  //   );
  //   // setActiveTab(key)
  // };
  const onChange = key => {
    if (!tabs[key]?.disabled) {
        // Allow switching to an enabled subtab
        dispatch(
            updateFormField({
                group: 'carrier',
                key: 'currentSubTab',
                value: Number(key),
            })
        );
    } else {
        // Fallback to the first enabled subtab if the selected one is disabled
        const firstEnabledSubTab = tabs.findIndex(tab => !tab.disabled);
        dispatch(
            updateFormField({
                group: 'carrier',
                key: 'currentSubTab',
                value: firstEnabledSubTab,
            })
        );
    }
};

// useEffect(() => {
//     // Only run this check when NOT navigating between main tabs
//     const isNavigatingBetweenTabs = tabs.length !== previousTabs?.length;
    
//     if (!isNavigatingBetweenTabs) {
//         const validSubTab = tabs.find(
//             (tab, index) => index === currentSubTab && !tab.disabled
//         );
//         if (!validSubTab) {
//             const firstEnabledSubTab = tabs.findIndex(tab => !tab.disabled);
//             dispatch(
//                 updateFormField({
//                     group: 'carrier',
//                     key: 'currentSubTab',
//                     value: firstEnabledSubTab,
//                 })
//             );
//         }
//     }
// }, [currentSubTab, tabs]);

return (
    <div className={`${customClass}`}>
        <Tabs
            defaultActiveKey={
                tabs[currentSubTab]?.disabled
                    ? tabs.findIndex(tab => !tab.disabled)
                    : currentSubTab?.toString()
            }
            activeKey={currentSubTab?.toString()}
            onChange={onChange}
            className={`fullwidth-tabs`}
            {...rest}
        >
            {tabs.map(({ label, disabled, Component }, index) => (
                <TabPane
                    key={index}
                    disabled={disabled}
                    tab={
                        <div
                            className={`tab-timeline ${
                                disabled ? 'ant-tabs-tab-disabled' : ''
                            }`}
                        >
                            <div className="tab-timeline-label">{label}</div>
                        </div>
                    }
                >
                    <Row>
                        <Col span={12}>
                            <ApplicationStatusOverview
                                id={businessKey}
                                activeTaskName={activeTaskName}
                            />
                        </Col>
                    </Row>
                    <Component {...tabProps} />
                </TabPane>
            ))}
        </Tabs>
    </div>
);
};

export default CustomTabsTimelineSub;
